export default "__VITE_ASSET__b4289ba3__"